<template>
  <v-footer v-if='showFooter' class='content footer'>
    <div class="left-container">
       <div class='footer-image'>
        <img alt="Company logo." src="img/1x1.png" class="footer-logo">
      </div>

    </div><!-- left end -->
    <div class="middle-container">
     <div class='footer-social-media'>
        <a v-if='messages.footerFacebookLink' :href='messages.footerFacebookLink' target="_blank"
          >
          <img class='footer-social-media-img' :alt='messages.footerFacebookAria' src="img/facebook.png"></a>
        <a v-if='messages.footerTwitterLink' :href='messages.footerTwitterLink' target="_blank">
          <img class='footer-social-media-img' :alt='messages.footerTwitterAria' src="img/twitter.png"></a>
        <a v-if='messages.footerInstagramLink' :href='messages.footerInstagramLink' target="_blank" >
          <img class='footer-social-media-img' :alt='messages.footerInstagramAria' src="img/instagram.png"></a>
        <a v-if='messages.footerYoutubeLink' :href='messages.footerYoutubeLink' target="_blank">
          <img class='footer-social-media-img' :alt='messages.footerYoutubeAria' src="img/youtube.png"></a>
        <a v-if='messages.footerLinkedInLink' :href='messages.footerLinkedInLink' target="_blank">
          <img class='footer-social-media-img' :alt='messages.footerLinkedInAria' src="img/linkedin.png"></a>
      </div>
    </div>
    <div class="right-container">
    <div class="footer-privacy-links">
      <div class="footer-privacy-link">
        <a v-if='messages.footerLink1' :href='messages.footerLink1' target="_blank" >
          <span class="link-label">{{messages.footerLink1Label}}</span>

        </a>
      </div>
      <div v-if='messages.footerLink2' class="link-separator">|</div>
      <div v-if='messages.footerLink2' class="footer-privacy-link">
        <a  :href='messages.footerLink2' target="_blank" >
          <span class="link-label">{{messages.footerLink2Label}}</span>
        </a>
      </div>
      <div v-if='messages.footerLink3' class="link-separator">|</div>
      <div v-if='messages.footerLink3' class="footer-privacy-link">
        <a :href='messages.footerLink3' target="_blank" >
          <span class="link-label">{{messages.footerLink3Label}}</span>
        </a>
      </div>
      <div v-if='messages.footerLink4' class="link-separator">|</div>
      <div v-if='messages.footerLink4' class="footer-privacy-link">
        <a :href='messages.footerLink4' target="_blank" >
          <span class="link-label">{{messages.footerLink4Label}}</span>
        </a>
      </div>
      <div v-if='messages.footerLink5' class="link-separator">|</div>
      <div v-if='messages.footerLink5' class="footer-privacy-link">
        <a :href='messages.footerLink5' target="_blank" >
          <span class="link-label">{{messages.footerLink5Label}}</span>
        </a>
      </div>
      <div  v-if='messages.footerLink6' class="link-separator">|</div>
      <div  v-if='messages.footerLink6' class="footer-privacy-link">
        <a v-if='messages.footerLink6' :href='messages.footerLink6' target="_blank" >
          <span class="link-label">{{messages.footerLink6Label}}</span>
        </a>
      </div>
    </div>
    </div>
  </v-footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CustomFooter',
  data: () => ({
    customLinksClass: '',
    showFooter: false
  }),
  computed: {
    ...mapState([
      'messages',
      'selectedLanguage',
      'configuration'
    ])
  },
  methods: {
  },
  watch: {
    selectedLanguage () {
      if (this.messages.footerLink4) { this.customLinksClass = 'footer-privacy-links' } else { this.customLinksClass = 'footer-privacy-links marginTop' }
    },
    configuration () {
      this.showFooter = this.configuration.showFooter
    }

  }

}
</script>

<style lang="scss">

  .footer-logo{
    float:left;
    max-height: 50px;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    content: var(--logo-footer-path);
  }
  .footer {
    background-color: var(--footer-bg-color) !important;
    color: var(--footer-color) !important;
    font-size:12px;
    float: left;
    padding: 15px;
  }
  .footer-social-media{
    float: left;
    padding: 10px;
    width: 100%;
    img{
        vertical-align: middle;
    }
  }
  .footer-privacy-links{
    padding: 10px;
  }
  .footer a, .footer a:active, .footer a:link, .footer a:visited{
    color: var(--footer-color) !important;
    text-decoration: none !important;
    outline: none !important;
    border: none !important;
  }

  .footer a:hover{
    color: var(--footer-hover-color) !important;
    text-decoration: underline !important;
    outline: none !important;
  }

  .footer-privacy-link {
    float: left;
    vertical-align: middle;
  }
  .link-separator{
    margin-left: 5px;
    margin-right: 5px;
    float: left;
  }

  .left-container{
    width: 15%;
    float: left;
  }

  .middle-container {
    width: 20%;
    float: left;
  }
  .right-container{
    width: 60%;
    float: left;
    vertical-align: middle;
    height:100%;
  }

@media screen and (max-width: 800px) {
  .left-container{
    width: 20%;
    float: left;
  }
  .middle-container{
    width: 25%;
    float: left;
  }

  .right-container{
    width: 50%;
    float: left;
  }
}

@media screen and (max-width: 600px) {
  .footer-logo{
    max-height: 50px;
    width: 100px;
    background-size: contain;
    -webkit-background-size: contain;
  }
  .left-container{
    width: 30%;
    float: left;
    padding: 10px
  }
  .middle-container{
    width: 60%;
    float: left;
  }

  .right-container{
    width: 100%;
    float: left;
  }

  .footer-privacy-link{
    width: 100%;
  }

  .link-separator{
    display: none;
  }
}

@media screen and (max-width: 300px) {
  .footer-logo{
    max-height: 50px;
    min-width: 70px;
    background-size: contain;
    -webkit-background-size: contain;
  }
  .left-container {
    width: 100%;
  }
  .middle-container {
    width: 100%;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .footer-logo{
    background-image: var(--logo-footer-path);
    background-size: contain;
    background-repeat: no-repeat;
    width: 80%;
    padding: 1%;
    content: none;
  }
}

</style>
